<cds-icon
  class="icon-margin"
  icon="action:info_1"
  (mouseenter)="onCanDelegateAmtToggle($event)"
  (mouseleave)="onCanDelegateAmtToggle($event)"
  cdsTooltip="{{ tooltipString | lang }}"></cds-icon>
